import React, { useEffect, useState } from "react";
import { Container, Button, Form, Row, Col } from "react-bootstrap";
import img from "../../../assets/images/contact-image.png";
import { useRouter } from "../../../util/router";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import "./styles.scss";
import { Spring } from "react-spring/renderprops";
import { handleAddressSelect } from "./helper";

const EnterAddress = ({ refCode }) => {
  const router = useRouter();
  const [selectedAddress, setSelectedAddress] = useState("");
  const [proceed, setProceed] = useState(false);
  const googleImageUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${selectedAddress}&zoom=21&size=700x700&maptype=satellite&key=${process.env.REACT_APP_GOOGLE_MAP_API}`;

  useEffect(() => {
    !selectedAddress && setProceed(false);
  }, [selectedAddress]);

  return (
    <>
      <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {(props) => (
          <Container style={props} className="multi-form-step-section">
            <span>
              {" "}
              <div>
                <img src={img} className="toast-image" alt="Helper Profile" />
              </div>
              <h5> Where Is Your Home Address?</h5>
            </span>

            <div className=" solar-address ">
              <PlacesAutocomplete
                value={selectedAddress}
                onChange={(address) => setSelectedAddress(address)}
                onSelect={() =>
                  handleAddressSelect(
                    selectedAddress,
                    geocodeByAddress,
                    getLatLng
                  )
                }
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading,
                }) => (
                  <div>
                    <Row>
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="sunroof-input-label">
                            Address
                          </Form.Label>
                          <Form.Control
                            {...getInputProps({
                              placeholder: "Enter Your Address",
                              className: "form-control sunroof-input",
                            })}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    {!proceed && (
                      <>
                        {loading && <div>Loading...</div>}
                        {suggestions && suggestions.length > 0 && (
                          <div
                            className={
                              "autocomplete-dropdown-container shadow-sm "
                            }
                          >
                            {suggestions.map((suggestion, i) => {
                              const className = suggestion.active
                                ? "suggestion-item--active"
                                : "suggestion-item";
                              // inline style for demonstration purpose
                              const style = suggestion.active
                                ? {
                                    backgroundColor: "#eee",
                                    cursor: "pointer",
                                  }
                                : {
                                    cursor: "pointer",
                                  };
                              return (
                                <div
                                  key={`${suggestion.description} ${i}`}
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                  })}
                                  onClick={() => {
                                    setSelectedAddress(suggestion.description);
                                    setProceed(true);
                                  }}
                                >
                                  {suggestion.description}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                )}
              </PlacesAutocomplete>

              {selectedAddress && proceed && (
                <>
                  {/* <div className="roof-preview-image-section">
                    <img
                      className="roof-preview-img"
                      src={googleImageUrl}
                      alt="Preview"
                    />
                  </div> */}

                  <Button
                    onClick={() =>
                      router.push(
                        `${router.pathname}?address=${selectedAddress}${
                          refCode && "&ref=" + refCode
                        }`
                      )
                    }
                    className="mx-auto d-block mt-4 own-home-btn sunroof-primary-btn   "
                  >
                    Continue
                  </Button>
                </>
              )}
            </div>
          </Container>
        )}
      </Spring>
    </>
  );
};

export default EnterAddress;
